export class ItemBusquedaModel {

	public Id: string = "";
	public Descripcion: string = "";

	constructor() {}
}